import {
  MockMap,
} from '@ama-sdk/core';
import {
  Email,
  Journey,
  JourneyElementAcceptance,
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineJourneys,
  combineJourneyTravelers,
  ContextualSeatmapDataRepository,
  createJourney,
  createMockData,
  createMockDataWithResponse,
  JourneyTravelerRepository,
  RecursivePartial,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';

const email1: Email = {
  address: 'first.traveler@amadeus.com',
  category: 'personal',
  contactType: 'Email',
  purpose: 'notification'
};

const email2: Email = {
  address: 'second.traveler@amadeus.com',
  category: 'personal',
  contactType: 'Email',
  purpose: 'notification'
};

const journeyTemplate: RecursivePartial<Journey> = {
  travelers: combineJourneyTravelers([JourneyTravelerRepository.MAN, JourneyTravelerRepository.INF, JourneyTravelerRepository.CHD], {}).items,
  contacts: [email1, email2]
};

const journeys = combineJourneys([journeyTemplate]).items;
const journeyElements: JourneyElementCommon[] = journeys[0].journeyElements.map((je, index) => ({
  ...je,
  journeyElement: {
    ...je.journeyElement,
    acceptance: index < 2 ? AcceptanceRepository.ACCEPTED as JourneyElementAcceptance : je.journeyElement.acceptance
  }
}));
const journeyElementIds = journeys[0].journeyElements.map((je: JourneyElementCommon) => je.id);
/**
 * OW 1 Journey
 * Check-in 1ADT, 1INF + check-in 1CHD
 * No baggage
 */
export const ow1Journey1Adt1Chd1InfMultiPaxsRetrieve: MockMap = {
  generateBoardingPasses: [createMockDataWithResponse(combineBoardingPassResults(undefined, {
    journeyElementIds
  }).items, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [{
    code: '10000',
    title: 'No unpaid service',
    type: 'error',
    id: '10000'
  }])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([
      createJourney({
        template: {
          ...journeys[0],
          journeyElements
        }
      })
    ], 201)
  ],
  retrieveJourney: [
    createMockData(
      createJourney({
        template: {
          ...journeys[0],
          travelers: journeys[0].travelers.filter((_, index, array) => array.length - 1 > index),
          acceptance: AcceptanceRepository.ACCEPTED
        }
      })
    )
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(ContextualSeatmapDataRepository.DEFAULT)],
  removeTravelersFromJourney: [createMockData({})]
};

// const firstRound: MockMap = {};
// const secondRound: MockMap = {};

// const mock: MockMap = {
//   removeTravelersFromJourney: [...firstRound.removeTravelersFromJourney, ...secondRound.removeTravelersFromJourney]
// }
